let reportSelects = {}

// Warning beware increasing number of columns in this query as Athena slows significantly with a large number of groups

let groupByManagedSpacesWithInfo = ['group_by_managedspace_id']
let occupancyData = [
  'select_managedspace_info',
  'select_grouped_occupancy_metrics',
  'select_grouped_environmental_sum_count',
  'select_grouped_environmental_min_max'
]

let environmentalData = occupancyData

// let defaultServerRequestGroups = ['space_position', 'space_department', 'space_type', 'floor_number', 'working_hours']

reportSelects.reportTypeDropdownItems = [
  {
    text: 'Average Occupants When Used',
    value: {
      serverRequestGroups: occupancyData,
      columnPlotted: 'ave_occupant_in_used_periods',
      percent: false,
      axisLabel: 'Ave Occupants When Used',
      graphTitle: 'Ave Occupants When Used',
      description: 'Average number of occupants recorded in the space for the period when the space was in use.'
    }
  },
  {
    text: 'Average Occupants When Available',
    value: {
      serverRequestGroups: occupancyData,
      columnPlotted: 'ave_occupant_in_all_periods',
      percent: false,
      axisLabel: 'Ave Occupants When Available',
      graphTitle: 'Ave Occupants When Available',
      description: 'Average number of occupants recorded in the space for the entire period the space was available to be used.'
    }
  },
  {
    text: 'Occupancy Percentage When Used',
    value: {
      serverRequestGroups: occupancyData,
      columnPlotted: 'percent_occupancy_in_used_periods',
      percent: true,
      axisLabel: 'Occupancy % When Used',
      graphTitle: 'Occupancy % When Used',
      description: 'A measure of how well the space is used, but only for the periods where the space is used. 100% represents full use of the space.'
    }
  },
  {
    text: 'Occupancy Percentage When Available',
    value: {
      serverRequestGroups: occupancyData,
      columnPlotted: 'percent_occupancy_all_periods',
      percent: true,
      axisLabel: 'Occupancy % When Available',
      graphTitle: 'Occupancy % When Available',
      description: 'A measure of how well the space is used for all of the periods where the space was available to be used. 100% represents full use of the space.'
    }
  },
  {
    text: 'Frequency Of Use Percentage',
    value: {
      serverRequestGroups: occupancyData,
      columnPlotted: 'percent_frequency_of_use',
      percent: true,
      axisLabel: 'Frequency Of Use %',
      graphTitle: 'Frequency Of Use %',
      description: 'A measure of how often the space is used. 100% represents the space being used all of the time.'
    }
  },
  {
    text: 'Utilisation Percentage',
    value: {
      serverRequestGroups: occupancyData,
      columnPlotted: 'percentage_utilisation',
      percent: true,
      axisLabel: 'Utilisation %',
      graphTitle: 'Utilisation %',
      description: 'An efficiency measure of the overall use taking into account both the frequency and occupancy of the space'
    }
  },
  {
    text: 'Maximum Number Occupants Per Space',
    value: {
      serverRequestGroups: occupancyData,
      columnPlotted: 'max_occupant',
      percent: false,
      axisLabel: 'Maximum Occupants (Per Space)',
      graphTitle: 'Maximum Occupants (Per Space)',
      description: 'Maximum number of occupants seen in the sample period'
    }
  },
  {
    text: 'Seat Hours',
    value: {
      serverRequestGroups: occupancyData,
      columnPlotted: 'seat_hours',
      percent: false,
      axisLabel: 'Seat Hours',
      graphTitle: 'Seat Hours',
      description: 'Total hours each seat is occupied'
    }
  },
  {
    text: 'Average Temperature ',
    value: {
      serverRequestGroups: environmentalData,
      columnPlotted: 'temp_avg',
      percent: false,
      axisLabel: 'Average Temperature',
      graphTitle: 'Average Temperature',
      description: 'Average of temperature per MS and sample period'
    }
  },
  {
    text: 'Minimum Temperature ',
    value: {
      serverRequestGroups: environmentalData,
      columnPlotted: 'temp_min',
      percent: false,
      axisLabel: 'Minimum Temperature',
      graphTitle: 'Minimum Temperature',
      description: 'Minimum of temperature per MS and sample period'
    }
  },
  {
    text: 'Maximum Temperature ',
    value: {
      serverRequestGroups: environmentalData,
      columnPlotted: 'temp_max',
      percent: false,
      axisLabel: 'Maximum Temperature',
      graphTitle: 'Maximum Temperature',
      description: 'Maximum of temperature per MS and sample period'
    }
  },

  {
    text: 'Average VOC ',
    value: {
      serverRequestGroups: environmentalData,
      columnPlotted: 'tvoc_avg',
      percent: false,
      axisLabel: 'Average VOC',
      graphTitle: 'Average VOC',
      description: 'Average of VOC per MS and sample period'
    }
  },
  {
    text: 'Minimum VOC ',
    value: {
      serverRequestGroups: environmentalData,
      columnPlotted: 'tvoc_min',
      percent: false,
      axisLabel: 'Minimum VOC',
      graphTitle: 'Minimum VOC',
      description: 'Minimum of VOC per MS and sample period'
    }
  },
  {
    text: 'Maximum VOC ',
    value: {
      serverRequestGroups: environmentalData,
      columnPlotted: 'tvoc_max',
      percent: false,
      axisLabel: 'Maximum VOC',
      graphTitle: 'Maximum VOC',
      description: 'Maximum of VOC per MS and sample period'
    }
  },

  {
    text: 'Average Co2 ',
    value: {
      serverRequestGroups: environmentalData,
      columnPlotted: 'co2_avg',
      percent: false,
      axisLabel: 'Average Co2',
      graphTitle: 'Average Co2',
      description: 'Average of Co2 per MS and sample period'
    }
  },
  {
    text: 'Minimum Co2 ',
    value: {
      serverRequestGroups: environmentalData,
      columnPlotted: 'co2_min',
      percent: false,
      axisLabel: 'Minimum Co2',
      graphTitle: 'Minimum Co2',
      description: 'Minimum of Co2 per MS and sample period'
    }
  },
  {
    text: 'Maximum Co2 ',
    value: {
      serverRequestGroups: environmentalData,
      columnPlotted: 'co2_max',
      percent: false,
      axisLabel: 'Maximum Co2',
      graphTitle: 'Maximum Co2',
      description: 'Maximum of Co2 per MS and sample period'
    }
  },

  {
    text: 'Average Humidity ',
    value: {
      serverRequestGroups: environmentalData,
      columnPlotted: 'humid_avg',
      percent: false,
      axisLabel: 'Average Humidity',
      graphTitle: 'Average Humidity',
      description: 'Average of Humidity per MS and sample period'
    }
  },
  {
    text: 'Minimum Humidity ',
    value: {
      serverRequestGroups: environmentalData,
      columnPlotted: 'humid_min',
      percent: false,
      axisLabel: 'Minimum Humidity',
      graphTitle: 'Minimum Humidity',
      description: 'Minimum of Humidity per MS and sample period'
    }
  },
  {
    text: 'Maximum Humidity ',
    value: {
      serverRequestGroups: environmentalData,
      columnPlotted: 'humid_max',
      percent: false,
      axisLabel: 'Maximum Humidity',
      graphTitle: 'Maximum Humidity',
      description: 'Maximum of Humidity per MS and sample period'
    }
  },

  {
    text: 'Average Sound ',
    value: {
      serverRequestGroups: environmentalData,
      columnPlotted: 'snd_avg',
      percent: false,
      axisLabel: 'Average Sound',
      graphTitle: 'Average Sound',
      description: 'Average of Sound per MS and sample period'
    }
  },
  {
    text: 'Minimum Sound ',
    value: {
      serverRequestGroups: environmentalData,
      columnPlotted: 'snd_min',
      percent: false,
      axisLabel: 'Minimum Sound',
      graphTitle: 'Minimum Sound',
      description: 'Minimum of Sound per MS and sample period'
    }
  },
  {
    text: 'Maximum Sound ',
    value: {
      serverRequestGroups: environmentalData,
      columnPlotted: 'snd_max',
      percent: false,
      axisLabel: 'Maximum Sound',
      graphTitle: 'Maximum Sound',
      description: 'Maximum of Sound per MS and sample period'
    }
  },
  {
    text: 'Average Light ',
    value: {
      serverRequestGroups: environmentalData,
      columnPlotted: 'lux_avg',
      percent: false,
      axisLabel: 'Average Light',
      graphTitle: 'Average Light',
      description: 'Average of Light per MS and sample period'
    }
  },
  {
    text: 'Minimum Light ',
    value: {
      serverRequestGroups: environmentalData,
      columnPlotted: 'lux_min',
      percent: false,
      axisLabel: 'Minimum Light',
      graphTitle: 'Minimum Light',
      description: 'Minimum of Light per MS and sample period'
    }
  },
  {
    text: 'Maximum Light ',
    value: {
      serverRequestGroups: environmentalData,
      columnPlotted: 'lux_max',
      percent: false,
      axisLabel: 'Maximum Light',
      graphTitle: 'Maximum Light',
      description: 'Maximum of Light per MS and sample period'
    }
  },
  {
    text: 'Average Pressure ',
    value: {
      serverRequestGroups: environmentalData,
      columnPlotted: 'pressure_avg',
      percent: false,
      axisLabel: 'Average Pressure',
      graphTitle: 'Average Pressure',
      description: 'Average of Pressure per MS and sample period'
    }
  },
  {
    text: 'Minimum Pressure ',
    value: {
      serverRequestGroups: environmentalData,
      columnPlotted: 'pressure_min',
      percent: false,
      axisLabel: 'Minimum Pressure',
      graphTitle: 'Minimum Pressure',
      description: 'Minimum of Pressure per MS and sample period'
    }
  },
  {
    text: 'Maximum Pressure ',
    value: {
      serverRequestGroups: environmentalData,
      columnPlotted: 'pressure_max',
      percent: false,
      axisLabel: 'Maximum Pressure',
      graphTitle: 'Maximum Pressure',
      description: 'Maximum of Pressure per MS and sample period'
    }
  }

  /*
  {
    text: 'Minimum Number Occupants',
    value: {
      columnPlotted: 'min_occupant',
      percent: false,
      axisLabel: 'Minimum Occupants',
      graphTitle: 'Minimum Occupants',
      description: 'Minimum number of occupants seen in the sample period'
    }
  }
  */
]

reportSelects.reportGroupDropdownItems = [
  {
    text: 'By Space Type',
    disabled: false,
    value: {
      serverRequestGroups: groupByManagedSpacesWithInfo,
      displayGroups: ['space_type'],
      showSpaceFilter: true,
      description: 'Group by the type of space, for example desk, meeting room, informal meeting area.'
    }
  },
  {
    text: 'By Department',
    disabled: false,
    value: {
      serverRequestGroups: groupByManagedSpacesWithInfo,
      displayGroups: ['space_department'],
      showSpaceFilter: true,
      description: 'Group by departments with spaces allocated to them.'
    }
  },
  {
    text: 'By Position',
    disabled: false,
    value: {
      serverRequestGroups: groupByManagedSpacesWithInfo,
      displayGroups: ['space_position'],
      showSpaceFilter: true,
      description: 'Group by the physical position of a desk within the building.'
    }
  },
  {
    text: 'By Floor',
    disabled: false,
    value: {
      serverRequestGroups: groupByManagedSpacesWithInfo,
      displayGroups: ['floor_number'],
      showSpaceFilter: true,
      description: 'Group by the building floor number.'
    }
  },
  {
    text: 'By Managed Space',
    disabled: false,
    value: {
      serverRequestGroups: groupByManagedSpacesWithInfo,
      displayGroups: ['managedspace_name'],
      showSpaceFilter: true,
      description: 'Show individual managed spaces.'
    }
  },
  // {
  // reportGroupDropdownItems

  //   text: 'By Hour of Day (Future)',
  //   disabled: true,
  //   value: {
  //     serverRequestGroups: ['hour'],
  //     displayGroups: ['hour'],
  //     showSpaceFilter: false,
  //     description: 'Group by the hour of the day.'
  //   }
  // },
  {
    text: 'None',
    disabled: false,
    value: {
      serverRequestGroups: groupByManagedSpacesWithInfo,
      displayGroups: [],
      showSpaceFilter: false,
      description: 'No grouping selected.'
    }
  }
]

reportSelects.reportAggregationDropdownItems = [
  {
    text: 'Day Of Week',
    value: {
      textLong: 'Day Of Week',
      serverRequestGroups: ['group_by_day_of_week'],
      displayGroups: ['day_of_week'],
      managedSpaces: true,
      showExtendedPeriodWarning: false,
      maxDays: 400
    }
  },
  /*
  {
    text: 'Date',
    value: {
      textLong: 'Date',
      serverRequestGroups: ['managedspace_id', 'ddmmyyyy', 'day_of_week'],
      displayGroups: ['ddmmyyyy'],
      managedSpaces: true,
      showExtendedPeriodWarning: false,
      maxDays: 35
    }
  },
  */
  {
    text: 'Date',
    value: {
      textLong: 'Date',
      serverRequestGroups: ['group_by_date'],
      displayGroups: ['date'],
      managedSpaces: true,
      showExtendedPeriodWarning: false,
      maxDays: 35
    }
  },
  /*
  {
    text: 'Date (Extended Range)',
    value: {
      textLong: 'Date',
      serverRequestGroups: ['ddmmyyyy'],
      displayGroups: ['ddmmyyyy'],
      managedSpaces: false,
      showExtendedPeriodWarning: true,
      maxDays: 0
    }
  },
  */
  {
    text: 'By Week Number / Year',
    value: {
      textLong: 'By Week Number',
      serverRequestGroups: ['group_by_week_year'],
      displayGroups: ['week_year'],
      managedSpaces: true,
      showExtendedPeriodWarning: false,
      maxDays: 400
    }
  },
  {
    text: 'By Month',
    value: {
      textLong: 'By Month',
      serverRequestGroups: ['group_by_month'],
      displayGroups: ['yyyymm'],
      managedSpaces: true,
      showExtendedPeriodWarning: false,
      maxDays: 400
    }
  },
  {
    text: 'By Year',
    value: {
      textLong: 'By Year',
      serverRequestGroups: ['group_by_year'],
      displayGroups: ['year'],
      managedSpaces: true,
      showExtendedPeriodWarning: false,
      maxDays: 0
    }
  }
  // {
  //   text: '30 Min (test)',
  //   value: {
  //     textLong: '30 Min (hack test)',
  //     serverRequestGroups: ['group_by_30_min_period'],
  //     displayGroups: ['date_time_local'],
  //     managedSpaces: true,
  //     showExtendedPeriodWarning: false,
  //     maxDays: 1
  //   }
  // }
]

export default reportSelects
